module.exports = __webpack_public_path__ + "img/POZZO_asset_5.6e075aee.jpg";